module.exports = __webpack_public_path__ + "static/media/yunjiadajianshan_mobile.8dfaf840.png";